// FaceBook 标准事件
const AD_FB_EVENT = [
  { label: '完成注册 CompleteRegistration', value: 'CompleteRegistration' },
  { label: '联系 Contact', value: 'Contact' },
  { label: '潜在客户 Lead', value: 'Lead' },
  { label: '提交申请 SubmitApplication', value: 'SubmitApplication' },
  { label: '订阅 Subscribe', value: 'Subscribe' },
  { label: '查看内容 ViewContent', value: 'ViewContent' },
  { separator: true },
  { label: '添加支付信息 AddPaymentInfo', value: 'AddPaymentInfo' },
  { label: '加入购物车 AddToCart', value: 'AddToCart' },
  { label: '加入心愿单 AddToWishlist', value: 'AddToWishlist' },
  { label: '定制商品 CustomizeProduct', value: 'CustomizeProduct' },
  { label: '捐款 Donate', value: 'Donate' },
  { label: '查找网点 FindLocation', value: 'FindLocation' },
  { label: '发起结账 InitiateCheckout', value: 'InitiateCheckout' },
  { label: '购物 Purchase', value: 'Purchase' },
  { label: '排期 Schedule', value: 'Schedule' },
  { label: '搜索 Search', value: 'Search' },
  { label: '开始试用 StartTrial', value: 'StartTrial' },
];

const AD_FB_EVENT_LIST = [
  'CompleteRegistration',
  'Contact',
  'Lead',
  'SubmitApplication',
  'Subscribe',
  'ViewContent',
  'AddPaymentInfo',
  'AddToCart',
  'AddToWishlist',
  'CustomizeProduct',
  'Donate',
  'FindLocation',
  'InitiateCheckout',
  'Purchase',
  'Schedule',
  'Search',
  'StartTrial',
];
module.exports = { AD_FB_EVENT, AD_FB_EVENT_LIST };
